import { adminConstants } from "../constant/admin-constant";

const initialState = {
    loadingOrder: false,
    ordersData: [],
    cartsListData: [],
    order: {}
};

export function ordersReducer(state = initialState, action) {
    switch (action.type) {
        case adminConstants.PAGINATION_ORDERS_REQUEST:
            return {
                ...state,
                loadingOrder: true
            };
        case adminConstants.PAGINATION_ORDERS_SUCCESS:
            return {
                ...state,
                ordersData: action.payload.orders.data,
                pages: action.payload.orders.last_page,
                loadingOrder: false,
                current_page: action.payload.orders.current_page,
                total_orders: action.payload.orders.total
            };
        case adminConstants.PAGINATION_CARTS_SUCCESS:
            return {
                ...state,
                cartsListData: action.payload.carts.data,
                pages: action.payload.carts.last_page,
                loadingOrder: false,
                current_page: action.payload.carts.current_page,
                total_orders: action.payload.carts.total
            };
        case adminConstants.PAGINATION_ORDERS_FAILURE:
            return {
                ...state,
                loadingOrder: false,
                error: action.payload
            };
        case adminConstants.GET_ORDER_SUCCESS:
            return {
                ...state,
                loadingOrder: false,
                order: action.payload.order
            };
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/OrderReducer.jsx